import {uniq} from 'lodash';
import {PointCoords} from '@/map/@types';

/** 시/도 정렬이 필요한 경우 이 배열을 바로 참조하지 말고 @/utils/location의 sortSido 함수를 사용하세요.
 * 시/도 데이터는 비정기적으로 변경될 가능성이 있습니다. */
export const SIDO_AREA_INFO: Array<{
  name: string;
  alias: string;
  sido: '시' | '도';
  order: number;
  bounds?: {min: PointCoords; max: PointCoords};
}> = [
  {
    name: '서울특별시',
    alias: '서울',
    sido: '시',
    order: 1,
    bounds: {
      min: [37.3716458, 126.484834],
      max: [37.8676595, 127.5010694],
    },
  },
  {
    name: '경기도',
    alias: '경기',
    sido: '도',
    order: 2,
    bounds: {
      min: [36.8888078, 126.0247815],
      max: [37.8839195, 128.0572522],
    },
  },
  {
    name: '인천광역시',
    alias: '인천',
    sido: '시',
    order: 3,
    bounds: {
      min: [36.9787175, 125.4093321],
      max: [37.9726425, 127.4418028],
    },
  },
  {
    name: '부산광역시',
    alias: '부산',
    sido: '시',
    order: 4,
    bounds: {
      min: [35.013466, 128.8128197],
      max: [35.2695063, 129.3209374],
    },
  },
  {
    name: '대전광역시',
    alias: '대전',
    sido: '시',
    order: 5,
    bounds: {
      min: [36.1937469, 127.1699775],
      max: [36.4460266, 127.6780952],
    },
  },
  {
    name: '대구광역시',
    alias: '대구',
    sido: '시',
    order: 6,
    bounds: {
      min: [35.7268882, 128.3506644],
      max: [35.9806683, 128.8587821],
    },
  },
  {
    name: '울산광역시',
    alias: '울산',
    sido: '시',
    order: 7,
    bounds: {
      min: [35.4062842, 129.0894949],
      max: [35.6610848, 129.5976126],
    },
  },
  {
    name: '세종특별자치시',
    alias: '세종',
    sido: '시',
    order: 8,
    bounds: {
      min: [36.3423229, 127.0596849],
      max: [36.5941216, 127.5678026],
    },
  },
  {
    name: '광주광역시',
    alias: '광주',
    sido: '시',
    order: 9,
    bounds: {
      min: [35.0845405, 126.7583332],
      max: [35.2125497, 127.012392],
    },
  },
  {
    name: '강원도',
    alias: '강원',
    sido: '도',
    order: 10,
    bounds: {
      min: [37.593718, 127.7861556],
      max: [38.0882514, 128.802391],
    },
  },
  {
    name: '강원특별자치도',
    alias: '강원',
    sido: '도',
    order: 10,
    bounds: {
      min: [37.593718, 127.7861556],
      max: [38.0882514, 128.802391],
    },
  },
  {
    name: '충청북도',
    alias: '충북',
    sido: '도',
    order: 11,
    bounds: {
      min: [36.6391079, 127.3463592],
      max: [36.8899408, 127.8544768],
    },
  },
  {
    name: '충청남도',
    alias: '충남',
    sido: '도',
    order: 12,
    bounds: {
      min: [36.3288403, 126.23777],
      max: [36.8317064, 127.2540054],
    },
  },
  {
    name: '경상북도',
    alias: '경북',
    sido: '도',
    order: 13,
    bounds: {
      min: [36.2956423, 128.40345],
      max: [36.7987238, 129.4196853],
    },
  },
  {
    name: '경상남도',
    alias: '경남',
    sido: '도',
    order: 14,
    bounds: {
      min: [35.1821097, 127.6510581],
      max: [35.6923205, 128.6672935],
    },
  },
  {
    name: '전라북도',
    alias: '전북',
    sido: '도',
    order: 15,
    bounds: {
      min: [35.5913189, 126.5737113],
      max: [36.0989318, 127.5899467],
    },
  },
  {
    name: '전북특별자치도',
    alias: '전북',
    sido: '도',
    order: 15,
    bounds: {
      min: [35.5913189, 126.5737113],
      max: [36.0989318, 127.5899467],
    },
  },
  {
    name: '전라남도',
    alias: '전남',
    sido: '도',
    order: 16,
    bounds: {
      min: [34.1685172, 125.6494864],
      max: [35.1983832, 127.6819572],
    },
  },
  {
    name: '제주특별자치도',
    alias: '제주',
    sido: '도',
    order: 17,
    bounds: {
      min: [32.9186704, 125.4105337],
      max: [33.9637452, 127.4430044],
    },
  },
];

export const SIDO_AREA_ALIAS = uniq([
  '전국',
  ...SIDO_AREA_INFO.map((i) => i.alias),
]);
